import React from 'react';
import { useSelector } from 'react-redux';
import classes from './ScoreboardHeaderItem.module.css';


const ScoreboardHeaderItem = ({ image, number, text, textKey, onClick, onMouseEnter, onMouseLeave, isActive = false, preserveSizeOnMobile = false, className: classNameProp }) => {

  const { texts } = useSelector(state => state.translate);

  return (
    <div className={`${classes.wrapper} ${onClick || onMouseEnter ? classes.clickable : ''} ${isActive ? classes.active : ''} ${preserveSizeOnMobile ? classes.preserveSizeOnMobile : ''} ${classNameProp || ''}`} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className={classes.statItem} >
        {image &&
            <img src={image} alt="" className={classes.icon} />
        }
        <div className={classes.content}>
            <div className={classes.text}>{texts[textKey]}</div>
            <div className={classes.number}>{number?.toLocaleString('he-IL')}</div>
        </div>
      </div>
    </div>
  );
};

export default ScoreboardHeaderItem;
